// extracted by mini-css-extract-plugin
module.exports = {"bid":"NFTSaleActions_bid__6tB1a"};